import { motion } from "framer-motion";

const DnsNetworkLayout = () => {
    return (
        <section className="py-24 px-6 bg-white text-center">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
            <h2 className="text-4xl font-bold text-gray-800 mb-16">DNS解析网络布局</h2>
            </motion.div>

            <div className="max-w-7xl mx-auto bg-white/80 border border-gray-200 shadow rounded-3xl p-10 space-y-14">
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="rounded-xl bg-blue-50 p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
                    >
                        <h3 className="text-sm font-medium text-blue-600 mb-2">全球DNS网络</h3>
                        <p className="text-xs text-gray-500 mb-4">支持全球任播及边缘节点多路接入</p>
                        <div className="rounded-xl px-4 py-4 text-white text-sm font-medium bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 transition-colors duration-300">
                            <div className="text-lg font-bold mb-1">Global Anycast</div>
                            <p className="leading-snug">
                                全球30+ DNS解析节点<br />
                                毫秒级响应延迟<br />
                                支持IPv4/IPv6双栈协议
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                        className="rounded-xl bg-violet-50 p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
                    >
                        <h3 className="text-sm font-medium text-violet-600 mb-2">智能调度中心</h3>
                        <p className="text-xs text-gray-500 mb-4">多地多活调度，精准解析出口</p>
                        <div className="rounded-xl px-4 py-4 text-white text-sm font-medium bg-gradient-to-br from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 transition-colors duration-300">
                            <div className="text-lg font-bold mb-1">Smart Routing</div>
                            <p className="leading-snug">
                                支持运营商识别调度<br />
                                就近节点优选回源<br />
                                负载均衡 & 异常切换
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                        className="rounded-xl bg-green-50 p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
                    >
                        <h3 className="text-sm font-medium text-green-600 mb-2">权威解析节点</h3>
                        <p className="text-xs text-gray-500 mb-4">覆盖全国三网直连 & 本地清洗</p>
                        <div className="space-y-2 text-white text-sm font-medium">
                            <div className="bg-blue-500 rounded-lg px-4 py-2 hover:bg-blue-600 transition-colors duration-300">电信骨干解析节点（BGP Anycast）</div>
                            <div className="bg-red-500 rounded-lg px-4 py-2 hover:bg-red-600 transition-colors duration-300">联通边缘加速节点（低延迟）</div>
                            <div className="bg-green-500 rounded-lg px-4 py-2 hover:bg-green-600 transition-colors duration-300">移动权威DNS节点（高出口）</div>
                        </div>
                    </motion.div>
                </div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.8 }}
                className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto mt-16"
            >
                {[
                    { value: "30+", label: "全球DNS节点规模" },
                    { value: "<30ms", label: "中国大陆平均响应" },
                    { value: "10M QPS+", label: "集群支持峰值解析" },
                    { value: "支持 DNSSEC / DoH", label: "安全协议能力" },
                ].map((item, i) => (
                    <div key={i} className="bg-gray-50 rounded-xl py-6 shadow-sm hover:shadow-md transition-shadow duration-300 text-sm">
                        <div className="text-indigo-600 text-xl font-bold">{item.value}</div>
                        <div className="mt-1 text-gray-600">{item.label}</div>
                    </div>
                ))}
            </motion.div>
        </section>
    );
};

export default DnsNetworkLayout;